import moment from "moment-timezone";
import { presenceStatuses } from "../residents";
export type AppStateResidentsActivityPlan = {
  activities: ResidentActivityMap;
  presences: ResidentPresenceyMap;
  configurations: ResidentConfigurationMap;
  isLoadingConfig: boolean;
  isLoadingActivities: boolean;
  isLoadingPresences: boolean;
  daysInfo: ResidentDate;
  feedbackOptions: FeedBackSkipOptions;
  skipOptions: FeedBackSkipOptions;
};
export type ResidentActivityMap = {
  [residentIdWithDate: string]: ActivityPlanItem[];
};

export type ResidentPresenceyMap = {
  [residentIdWithDate: string]: ResidentPresenceItem[];
};
export type FeedBackSkipOptions = {
  [key in ResidentActivityType]?: feedbackDTO;
};
export type ResidentDate = {
  [residentId: string]: ResidentInfo;
};
export type ResidentInfo = {
  [day: string]: boolean;
};

export type ResidentConfigurationMap = {
  [residentId: string]: OneResidentConfig;
};

export type OneResidentConfig = {
  [key in ResidentActivityType]?: ActivityConfiguration;
};

export type ActivityPlan = {
  [key in string]: ActivityPlanItem[];
};

export enum ResidentActivityType {
  DRINKING = "Drinking",
  EATING = "Eating",
  VITAL_SIGNS = "VitalSigns",
  SHOWER = "Shower",
  REPLACE_CLOTHING = "ReplaceClothing",
  PHYSIOTHERAPY = "Physiotherapy",
  CLEANING = "RoomCleaning",
  TEETH = "TeethReplacements",
  EAR_AID = "EarAid",
  PROSTHETIC = "ProstheticBodyPart",
  PRESSURE_ULCER_TREATEMENT = "PressureUlcerTreatment",
  CUTTING_NAILS = "CuttingNails",
  DIAPER = "DiaperReplacement",
  STANDING = "Standing",
  WALKING = "Walking",
  TOILET = "Toilet",
  PATROL = "Patrol",
}

export enum SubActivityType {
  HEART_RATE = "HeartRate",
  TEMPERATURE = "Temperature",
  BLOOD_PRESSURE = "BloodPressure",
  SPO2 = "SpO2",
}
export enum ActivityStatus {
  DONE = "Done",
  CREATED = "Created",
  REPORTED = "Reported",
  TIMEOUT = "Timeout",
  SKIPPED = "Skip",
  AutomaticallyDone = "AutomaticallyDone",
  ManualDone = "ManualDone",
  AWAY = "Away",
}
export const isDoneStatus = (status: ActivityStatus): boolean => {
  return (
    [
      ActivityStatus.DONE,
      ActivityStatus.ManualDone,
      ActivityStatus.AutomaticallyDone,
    ].indexOf(status) !== -1
  );
};

export type ActivityPlanItem = {
  type: ResidentActivityType;
  activityParams?: SubActivityType[];
  status: ActivityStatus;
  date?: string;
  utcDate: string;
};
export type ActivityPlanItemWithResident = {
  type: ResidentActivityType;
  activityParams?: SubActivityType[];
  status: ActivityStatus;
  date?: string;
  residentId: string;
};

export enum RepeatType {
  NoRepeat = "NoRepeat",
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
  Yearly = "Yearly",
}
export type ScheduleItem = {
  dayOfWeek?: string | null; // can be null,
  timeSchedule: string[];
};

export type ActivityConfiguration = {
  type: ResidentActivityType;
  activityParams?: SubActivityType[];
  repeatType: RepeatType;
  dedicatedTime: boolean;
  startDate: string;
  schedule: ScheduleItem[];
  endsNever: boolean | null;
  endDate: string | null;
  occurrencesLimit: number | null;
};
type stub = {
  stub: boolean;
};

export const ActivityConfigurationStub = (
  type: ResidentActivityType
): ActivityConfiguration & stub => {
  return {
    type: type,
    repeatType: RepeatType.Daily,
    startDate: new Date().toISOString(),
    activityParams: [],
    schedule: [],
    endsNever: true,
    dedicatedTime: false,
    endDate: null,
    occurrencesLimit: null,
    stub: true,
  };
};

export const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const getDayIndex = (str: string, round: boolean): number => {
  return !round
    ? days.indexOf(str)
    : []
        .concat(days[days.length - 1])
        .concat(days.slice(0, 6))
        .indexOf(str);
};
export const rangeDays = (a: ScheduleItem, b: ScheduleItem): number => {
  const start = moment().locale("en-gb").weekday(0);
  const startThere = moment().weekday(0);
  if (!start.isSame(startThere))
    return getDayIndex(a.dayOfWeek, true) - getDayIndex(b.dayOfWeek, true);
  return getDayIndex(a.dayOfWeek, false) - getDayIndex(b.dayOfWeek, false);
};

export const getDayName = (index: number): string => {
  if (index === -1) return days[days.length - 1];
  return days[index];
};

export type SendActivityDTO = {
  residentId: string;
  activityType: ResidentActivityType;
  activityParams?: string[];
  feedback: feedbackDTO;
};
export type feedbackDTO = {
  radioButtons?: Record<string, boolean | feedbackDTO>;
  checkBoxes?: Record<string, boolean | feedbackDTO>;
  values?: Record<string, string>;
  comment?: string;
  selected?: any;
};

// "radioButtons": {
//         "No outputs": false,
//         "Outputs": {
//             "checkBoxes":
//             {
//                 "Urine": false
//                 "Faces": {
//                     "radioButtons": {
//                         "Normal stool": false,
//                         "Diarrhea"
//                     }
//                 },
//             },
//         },
//         "Refused": false
//     },
export type Config_Socket_DTO = {
  activities: ActivityPlanItem[];
  activityConfiguration: ActivityConfiguration;
  residentId: string;
};

export type Config_Batch_Socket_DTO = {
  activities: ActivityPlanItem[];
  activityConfigurations: ActivityConfiguration[];
  residentId: string;
};

export type Delete_Socket_DTO = {
  activityType: ResidentActivityType;
  residentId: string;
};

export const ACTIVITIES_PER_ONE_TIME = 5;

export type skipActivityDTO = {
  residentId: string;
  activityType: ResidentActivityType;
  activityDate: string;
  activityParams: string[];
  utcActivityDate: string;
  feedback: {
    radioButtons?: Record<string, boolean>;
    checkBoxes?: Record<string, boolean>;
    values?: Record<string, string>;
    comment?: string;
  };
};

export type AddConfigDTO = {
  residentIds: string[];
  activityConfigurations: ActivityConfiguration[];
};

export const isSheduledActivity = (type: ResidentActivityType): boolean => {
  return (
    [ResidentActivityType.TOILET, ResidentActivityType.PATROL].indexOf(type) ===
    -1
  );
};

export type ResidentPresenceItem = {
  residentId: string;
  start: string;
  end: null | string;
  type: presenceStatuses;
};

export const presenceMock: ResidentPresenceItem[] = [
  {
    residentId: "24ee0ff5c80b433e82c27373b28b6712",
    end: "2025-02-04T06:00:00",
    start: "2025-02-04T04:00:00",
    type: presenceStatuses.away,
  },
  {
    residentId: "24ee0ff5c80b433e82c27373b28b6712",
    end: null,
    start: "2025-02-04T09:00:00",
    type: presenceStatuses.away,
  },
];

export const weirdData = (today) => {
  const dateStart = new Date(today); // Or the date you'd like converted.
  const start = new Date(
    dateStart.getTime() - dateStart.getTimezoneOffset() * 60000
  ).toISOString();
  return start.replace("Z", "");
};
